import { useEditorStore } from '../../store/editorStore';
import type { IControllerBridge, IInteractionStrategy } from './types';

/**
 * 绘制模式策略
 * 绘制中：忽略多边形选中，处理绘制完成，不响应 moveend
 */
export class DrawingStrategy implements IInteractionStrategy {
  onSelect(): void {
    // 绘制中忽略多边形选中
  }

  onDrawComplete(
    ctrl: IControllerBridge,
    result: boolean,
    feature?: any,
    id?: string | number,
    coordinates?: any
  ): void {
    if (result) {
      ctrl.resetInteractionState();
      useEditorStore.getState().setCreateFormMode({
        id: String(id ?? `draft_${Date.now()}`),
        feature,
        coordinates,
      });
    }
    // result=false 不再由本策略处理：
    // DrawingInteraction.handleDrawFail 已直接清空图形并提示错误，
    // 保持绘制会话让用户在同一模式下重新绘制，避免自动重入导致循环。
  }

  onMoveEnd(): void {
    // 绘制中不响应 moveend
  }
}
